(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-tabs"] && !Shopify.designMode) return;
  try {
    function switchTab(event, tabId) {
    const wrapper = event.target.closest('[data-product-tabs]');
    const buttons = wrapper.querySelectorAll('.tab-button');
    const panels = wrapper.querySelectorAll('.tab-panel');
    const indicator = wrapper.querySelector('[data-indicator]');
    const clickedButton = event.target;

    buttons.forEach(btn => btn.classList.remove('active'));
    panels.forEach(panel => panel.classList.remove('active'));

    clickedButton.classList.add('active');
    wrapper.querySelector(`[data-panel="${tabId}"]`).classList.add('active');

    const buttonIndex = Array.from(buttons).indexOf(clickedButton);
    const buttonWidth = clickedButton.offsetWidth;
    const leftPosition = buttonWidth * buttonIndex;

    indicator.style.width = `${buttonWidth}px`;
    indicator.style.transform = `translateX(${leftPosition}px)`;
  }

  document.addEventListener('DOMContentLoaded', function() {
  const wrappers = document.querySelectorAll('[data-product-tabs]');

  wrappers.forEach(wrapper => {
    const buttons = wrapper.querySelectorAll('.tab-button');
    const panels = wrapper.querySelectorAll('.tab-panel');
    const indicator = wrapper.querySelector('[data-indicator]');

    function activateTab(tabButton) {
      buttons.forEach(btn => btn.classList.remove('active'));
      panels.forEach(panel => panel.classList.remove('active'));

      tabButton.classList.add('active');
      const tabId = tabButton.dataset.tab;
      wrapper.querySelector(`[data-panel="${tabId}"]`).classList.add('active');

      const buttonIndex = Array.from(buttons).indexOf(tabButton);
      const buttonWidth = tabButton.offsetWidth;
      const leftPosition = buttonWidth * buttonIndex;

      indicator.style.width = `${buttonWidth}px`;
      indicator.style.transform = `translateX(${leftPosition}px)`;
    }

    // Initialize indicator
    const activeButton = wrapper.querySelector('.tab-button.active');
    if (activeButton) activateTab(activeButton);

    // Add click listeners
    buttons.forEach(btn => {
      btn.addEventListener('click', () => activateTab(btn));
    });

    // Update on resize
    window.addEventListener('resize', () => {
      const activeBtn = wrapper.querySelector('.tab-button.active');
      if (activeBtn) activateTab(activeBtn);
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
